import {useTranslation} from 'react-i18next'

import {useRefraSettings} from '@refra/modules/common/providers/RefraSettingsProvider'
import {CheckBox} from '@refra/modules/refra-planning/components/KilnShutdownsCard/CheckBox'

interface LocalColorToggleProps {
  dataCy?: string
}

export const LocalColorToggle: React.FC<LocalColorToggleProps> = ({
  dataCy = 'local-color-toggle'
}) => {
  const {t} = useTranslation()
  const {settings, setSettings} = useRefraSettings()

  const toggleColorMode = () => {
    setSettings({...settings, useLocalColors: !settings.useLocalColors})
  }

  return (
    <div
      className="flex items-center gap-2"
      data-cy={dataCy}
      title={t('localColors.toggleTooltip')}
    >
      <CheckBox
        label={t('localColors.globalColors')}
        checked={!settings.useLocalColors}
        onChange={toggleColorMode}
        data-cy={`${dataCy}-checkbox`}
      />
    </div>
  )
}
